import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FileUploadType } from '@core/models/file.model';
import { BatchUpdateService } from '@core/services/batch-update/batch-update.service';
import { FileUploadService } from '@core/services/file-upload.service';
import { BehaviorSubject } from 'rxjs';

@Component({
standalone: false,
  selector: 'app-tv-file-upload-popup',
  templateUrl: './tv-file-upload-popup.component.html',
  styleUrls: ['./tv-file-upload-popup.component.scss'],
})
export class TvFileUploadPopupComponent implements OnInit {
  public requiredFileType;
  public caller: any;
  public file: File = null;
  public uploadedFileName: string = null;
  public channelCode = null;
  public loading = false;
  public title = 'Importer le fichier';
  public actionButtonTitle = 'Importer le fichier';

  //TODO: add progress
  public fileUploadProgress$ = new BehaviorSubject(0);
  public shouldEmptyFileUploadInput = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<TvFileUploadPopupComponent>,
    protected batchUpdateService: BatchUpdateService,
    protected fileUploadService: FileUploadService,
    protected snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    if (this.data && this.data.title) {
      this.title = this.data.title;
    }
    if (this.data && this.data.requiredFileType) {
      this.requiredFileType = this.data.requiredFileType;
    }
    if (this.data && this.data.actionButtonTitle) {
      this.actionButtonTitle = this.data.actionButtonTitle;
    }
    if (this.data && this.data.caller) {
      this.caller = this.data.caller;
    }
    if (this.data && this.data.channelCode) {
      this.channelCode = this.data.channelCode;
    }
  }

  onUploadClick(file: File) {
    this.loading = true;
    this.fileUploadService.upload(file, FileUploadType.BatchUpdateThema).subscribe(
      fileName => {
        this.loading = false;
        this.file = file;
        this.uploadedFileName = fileName;
        this.caller.onUploadFinished(file);
      },
      error => {
        this.loading = false;
        this.file = null;
        this.uploadedFileName = null;
        this.snackBar.open("Une erreur est survenue lors l'envoi du fichier.", null, {
          duration: 2000,
          verticalPosition: 'top',
          panelClass: ['tv-chip-error'],
        });
      }
    );
  }

  onImportClick() {
    this.loading = true;
    this.batchUpdateService.importNbcBreakFile(this.uploadedFileName, this.channelCode).subscribe(
      fileName => {
        this.loading = false;
        this.caller.onImportFinished(this.uploadedFileName);
        this.file = null;
        this.uploadedFileName = null;
        this.onButtonClick(false);
      },
      error => {
        this.loading = false;
        this.file = null;
        this.uploadedFileName = null;
        if (error.status == 200) {
          this.snackBar.open('Le fichier a été importé avec succès.', null, {
            duration: 2000,
            verticalPosition: 'top',
            panelClass: ['tv-chip-success'],
          });
        } else {
          this.snackBar.open('Une erreur est survenue lors du traitement du fichier.', null, {
            duration: 2000,
            verticalPosition: 'top',
            panelClass: ['tv-chip-error'],
          });
        }
      }
    );
  }

  onButtonClick(confirmation: boolean) {
    this.dialogRef.close(confirmation);
  }
}
